import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { CarSubtype } from 'src/app/trip-calculator/models/transport';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';

@Component({
  selector: 'app-select-type',
  imports: [ReactiveFormsModule, TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-type.component.html',
})
export class SelectTypeComponent implements OnInit {
  transportFormService = inject(TransportFormService);
  translocoService = inject(TranslocoService);

  typeList: CategoryItem[] = [];
  subtypeList: CategoryItem[] = [];

  ngOnInit() {
    this.initializeTypeList();
    this.initializeSubtypeList();
  }

  initializeTypeList() {
    this.typeList = [];
    for (const type of this.transportFormService.typeList()) {
      this.typeList.push({
        value: type,
        label: this.translocoService.translate('categoryType.' + type),
      });
    }
  }
  initializeSubtypeList() {
    this.subtypeList = [];
    for (const subtype of Object.values(CarSubtype)) {
      this.subtypeList.push({
        value: subtype,
        label: this.translocoService.translate('car.' + subtype),
        description: this.translocoService.translate(
          'car.' + subtype + 'Exemple',
        ),
      });
    }
  }

  get type() {
    const type = this.transportFormService.transportForm.get('type')?.value;
    return type ? type : '';
  }

  set type(value) {
    this.transportFormService.transportForm.get('type')?.setValue(value);
  }

  get subtype() {
    const subtype =
      this.transportFormService.transportForm.get('subtype')?.value;
    return subtype ? subtype : '';
  }

  set subtype(value) {
    this.transportFormService.transportForm.get('subtype')?.setValue(value);
  }
}
